"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _models = require("@nopanoga/models");

var _Text = require("../../Text");

var _Theme = require("../../Theme");

var _ExerciceListItem = _interopRequireDefault(require("./ExerciceListItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = _reactNative.StyleSheet.create({
  container: {
    width: '100%',
    borderRadius: 8,
    overflow: 'hidden'
  },
  header: {
    backgroundColor: _Theme.darkColors.blocHeaderBg,
    height: 55,
    width: '100%',
    padding: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  headerTitleText: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  headerRepsText: {
    fontSize: 14
  },
  ExerciceListContainer: {
    padding: 16,
    backgroundColor: _Theme.darkColors.blocBg
  }
});

var Header = function Header(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ["style"]);

  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, _extends({}, props, {
    style: [styles.header, style]
  }));
};

var ExerciceListContainer = function ExerciceListContainer(_ref2) {
  var style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ["style"]);

  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, _extends({}, props, {
    style: [styles.ExerciceListContainer, style]
  }));
};

var _default = function _default(_ref3) {
  var bloc = _ref3.bloc,
      style = _ref3.style;
  var blocExercices = bloc.exercices || [];
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, style]
  }, /*#__PURE__*/_react["default"].createElement(Header, null, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    style: styles.headerTitleText,
    color: _Theme.darkColors.blocTitle
  }, bloc.title), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    style: styles.headerRepsText,
    color: _Theme.darkColors.blocTitle
  }, "x", bloc.volume)), /*#__PURE__*/_react["default"].createElement(ExerciceListContainer, null, blocExercices.map(function (blocExercice, i) {
    return /*#__PURE__*/_react["default"].createElement(_ExerciceListItem["default"], {
      key: blocExercice.id,
      blocExercice: blocExercice,
      style: {
        marginBottom: i === blocExercices.length - 1 ? 0 : 16
      }
    });
  })));
};

exports["default"] = _default;